export default __webpack_public_path__ + "static/media/BabyPunk.f271258b.gif";